import { Add, Edit, Delete } from '@mui/icons-material'
import { Box, Button, Grid, MenuItem, Pagination, Paper, Stack, Table, TableBody, TableHead, useTheme, } from '@mui/material'
import React from 'react'
import { useState, useEffect } from "react";
import { getAllUserRoles, removeUserFromRole } from '../apiServices/UserManagementApi';
import { AppUser } from '../helpers/interfaces';
import CreateEditUser from '../components/users/CreateEditUser';
import { FormEditMode } from '../helpers/constants';
import { getUserEmail, getUserFullName, showConfirmBox } from '../helpers/utils';
import { CustomTextField, StyledTableCell, StyledTableRow } from '../layouts/theme';



function UserList() {
    const theme = useTheme();
    const [users, setUsers] = useState<AppUser[]>([])
    const [filteredUsers, setFilteredUsers] = useState<AppUser[]>([])
    const [searchQuery, setSearchQuery] = useState<string>("");
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [recordsPerPage, setRecordsPerPage] = useState<number>(5);
    const [numOfPages, setNumOfPages] = useState<number>(0);
    const [currentPageRecords, setCurrentPageRecords] = useState<AppUser[]>([])
    const [openUserForm, setOpenUserForm] = React.useState(false);
    const [userEditMode, setUserEditMode] = React.useState(FormEditMode.CREATE);
    const [appUserToEdit, setAppUserToEdit] = useState<AppUser|null>(null);
    const handleOpenUserForm = () => {
        setUserEditMode(FormEditMode.CREATE);
        setOpenUserForm(true);
    };

    useEffect(() => {
        getAllUserRoles().then(e => {
            var usersGrouped = Array.from(e.reduce(
                (entryMap, e) => entryMap.set(
                    e.user_principal_id,
                    {
                        id: e.user_principal_id,
                        name: getUserFullName(e.user_principal_id),
                        email: getUserEmail(e.user_principal_id),
                        roles: [...entryMap.get(e.user_principal_id)?.roles || [], e.role]
                    }), new Map<string, AppUser>()
            ).values());
            setUsers(usersGrouped)
        })
    }, [])

    useEffect(() => {
        setFilteredUsers(users.filter(e =>
            (searchQuery === "" || e.name.toLowerCase().includes(searchQuery.toLowerCase()))
        ));
        setCurrentPage(1);
    }, [searchQuery, users])


    useEffect(() => {
        setNumOfPages(Math.ceil(filteredUsers.length / recordsPerPage))
    }, [recordsPerPage, filteredUsers])

    useEffect(() => {
        const lastIndex = currentPage * recordsPerPage;
        const firstIndex = lastIndex - recordsPerPage;
        setCurrentPageRecords(filteredUsers.slice(firstIndex, lastIndex))
    }, [currentPage, recordsPerPage, filteredUsers])

    const handleEdit = (user: AppUser) => {
        setAppUserToEdit(user)
        setUserEditMode(FormEditMode.EDIT);
        setOpenUserForm(true);
    }

    const deleteUser = (user: AppUser) => {
        showConfirmBox("Are you sure you want to Delete this User?", " Delete User")
            .then((result) => {
                if (result.isConfirmed)
                    for(var role in user.roles)
                        removeUserFromRole({user_principal_id:user.id, role:role}).then(() => setUsers(users => users.filter(u => u.id !== user.id)))
            })
    }

    return (
        <Box m="1.0rem 1.0rem">
            <div className=' font-bold text-lg' style={{ color: theme.palette.text.secondary }}>User List</div>
            <Box>
                <Paper>
                    <Box mt="10px" p='1.0rem' gap="20px">
                        <div className=" flex flex-row ">
                            <div className=' flex w-2/3 '>
                                <CustomTextField size="small" id="outlined-basic" placeholder="Search by Username..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} variant="outlined" sx={{ width: '50%' }} /> &nbsp;

                            </div>
                            <div style={{ flexGrow: 1 }} />

                            <Button color='secondary' variant="contained" style={{ textTransform: 'none', fontSize: 14, }} onClick={handleOpenUserForm}><Add />&nbsp;Create New User</Button>
                        </div>
                        <br />
                        <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                            <Table>
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell> SN</StyledTableCell>
                                        <StyledTableCell>Name</StyledTableCell>
                                        <StyledTableCell>Email</StyledTableCell>
                                        <StyledTableCell>Role</StyledTableCell>
                                        <StyledTableCell>Action</StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {currentPageRecords.map((item, index) => {
                                        return <StyledTableRow key={index}>

                                            <StyledTableCell>{index + 1 + ((currentPage - 1) * recordsPerPage)}</StyledTableCell>
                                            <StyledTableCell>{item.name}</StyledTableCell>
                                            <StyledTableCell>{item.email}</StyledTableCell>
                                            <StyledTableCell>{item.roles.join(", ")}</StyledTableCell>
                                            <StyledTableCell >
                                                <Button variant='outlined' color='info' size='small' onClick={() => { handleEdit(item) }}  ><Edit />&nbsp; Edit</Button>&nbsp;&nbsp;&nbsp;&nbsp;
                                                <Button variant='outlined' color='secondary' size='small' onClick={() => { deleteUser(item) }}   > <Delete />&nbsp; Delete</Button>

                                            </StyledTableCell>
                                        </StyledTableRow>
                                    })}

                                    {currentPageRecords.length === 0 &&
                                        <tr>
                                            <StyledTableCell colSpan={7}><p style={{ fontSize: '11px', textAlign: 'center' }}>No record available...</p></StyledTableCell>
                                        </tr>
                                    }
                                </TableBody>
                            </Table>
                        </div>

                        <br />

                        <nav>
                            <div className=" flex flex-row ">
                                <div className=" flex items-start ">
                                    <div className="px-6 py-2">Rows per page</div>&nbsp;
                                    < Grid item xs={12} lg={3} >
                                        <CustomTextField fullWidth id="fullWidth" select variant="outlined" size="small" name="RequestsNumbers" value={recordsPerPage} onChange={(e) => setRecordsPerPage(Number(e.target.value))} >
                                            <MenuItem value="5">5</MenuItem >
                                            <MenuItem value="15">15</MenuItem >
                                            <MenuItem value="25">25</MenuItem >
                                            <MenuItem value="40">40</MenuItem >
                                            <MenuItem value="55">55</MenuItem >
                                            <MenuItem value="85">85</MenuItem >
                                            <MenuItem value="125">125</MenuItem >
                                            <MenuItem value="200">200</MenuItem >
                                            <MenuItem value="255">255</MenuItem >
                                            <MenuItem value="350">350</MenuItem >
                                            <MenuItem value="500">500</MenuItem >


                                        </CustomTextField>
                                    </Grid>
                                </div>
                                <div style={{ flexGrow: 1 }} />
                                <Stack spacing={2}>
                                    <Pagination color="secondary" count={numOfPages} siblingCount={1} boundaryCount={1}
                                        onChange={(event, value) => setCurrentPage(value)} page={currentPage} size="small" classes={{ ul: "PaginationUl" }} />
                                </Stack>

                            </div>
                            <br />


                        </nav>

                        {openUserForm &&
                            <CreateEditUser appUserToEdit={appUserToEdit} formEditMode={userEditMode} setAppUsers={setUsers} openUserForm={openUserForm} setOpenUserForm={setOpenUserForm} />
                        }
                    </Box>
                </Paper>
            </Box>
        </Box>
    )
}

export default UserList